/**
 * Generated runtime TestId mirror for frontend/src/pages/ValueListDetail.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ValueListDetailTestIds = {
  btnAddEntry: "btn-add-entry",
  btnDeleteList: "btn-delete-list",
  btnEditList: "btn-edit-list",
  cardValueListDetails: "card-value-list-details",
  colActions: "col-actions",
  colActive: "col-active",
  colCode: "col-code",
  colDescription: "col-description",
  colDrag: "col-drag",
  colLabel: "col-label",
  entriesEmpty: "entries-empty",
  inputEditEntryDescription: "input-edit-entry-description",
  inputEditEntryLabel: "input-edit-entry-label",
  inputEditVlDescription: "input-edit-vl-description",
  inputEditVlDisplayName: "input-edit-vl-display-name",
  inputEntryCode: "input-entry-code",
  inputEntryDescription: "input-entry-description",
  inputEntryLabel: "input-entry-label",
  switchEditEntryActive: "switch-edit-entry-active",
  switchEditVlActive: "switch-edit-vl-active",
  valueListDetailPage: "value-list-detail-page",
  btnDeleteEntry: (entry_id: string) => `btn-delete-entry-${entry_id}`,
  btnDeleteEntryPrefix: () => "btn-delete-entry-" as TestIdPrefix,
  btnEditEntry: (entry_id: string) => `btn-edit-entry-${entry_id}`,
  btnEditEntryPrefix: () => "btn-edit-entry-" as TestIdPrefix,
  entryRow: (entry_id: string) => `entry-row-${entry_id}`,
  entryRowPrefix: () => "entry-row-" as TestIdPrefix
} as const;
